// extracted by mini-css-extract-plugin
export var closeButton = "_kc-1";
export var closeX = "_kc-3";
export var container = "_kc-0";
export var image = "_kc-2";